import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export const FAQ = () => {
  const [openItem, setOpenItem] = useState(null);

  const faqItems = [
    {
      id: 1,
      question: "Qual o horário de funcionamento?",
      answer: "Funcionamos de segunda a sexta-feira, das 7h às 18h30, oferecendo flexibilidade de horários para atender às necessidades das famílias."
    },
    {
      id: 2,
      question: "Como funciona a alimentação?",
      answer: "Oferecemos alimentação balanceada incluindo café da manhã, almoço e lanches. O cardápio é elaborado por nutricionista e adaptado para cada faixa etária."
    },
    {
      id: 3,
      question: "Posso agendar uma visita?",
      answer: "Sim! Realizamos visitas somente com agendamento. Entre em contato pelo telefone (19) 3242-5657 ou WhatsApp (19) 99344-5279 para agendar e conhecer nossa estrutura e proposta pedagógica."
    },
    {
      id: 4,
      question: "Qual a metodologia pedagógica?",
      answer: "Utilizamos uma proposta pedagógica interdisciplinar, com foco no desenvolvimento integral da criança através do lúdico, respeitando a individualidade de cada aluno."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <div className="inline-block mb-4">
              <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider bg-amber-100 px-4 py-2 rounded-full">
                Perguntas Frequentes
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Tire Suas Dúvidas
            </h2>
            <p className="text-lg text-gray-600">
              Respostas para as perguntas mais comuns sobre nossa escola
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="space-y-4">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="bg-gradient-to-r from-amber-50/50 to-orange-50/50 border-2 border-amber-100 rounded-2xl px-6 hover:border-amber-300 transition-colors"
              >
                <button
                  onClick={() => setOpenItem(openItem === item.id ? null : item.id)}
                  className="w-full text-left font-semibold text-gray-800 hover:text-amber-600 py-6 text-lg flex justify-between items-center"
                >
                  {item.question}
                  <ChevronDown 
                    className={`transform transition-transform ${openItem === item.id ? 'rotate-180' : ''}`}
                    size={24}
                  />
                </button>
                {openItem === item.id && (
                  <div className="text-gray-600 leading-relaxed pb-6 text-base">
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* CTA Box */}
          <div className="mt-12 bg-gradient-to-r from-amber-500 to-orange-500 rounded-3xl p-8 text-center shadow-xl">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Ainda tem dúvidas?
            </h3>
            <p className="text-white/90 text-lg mb-6">
              Entre em contato conosco! Estamos à disposição para ajudar.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/5519993445279"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-amber-600 font-semibold rounded-xl hover:bg-gray-50 shadow-lg hover:shadow-xl hover:scale-105 transition-all"
              >
                Fale no WhatsApp
              </a>
              <a
                href="tel:1932425657"
                className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-xl hover:bg-white/20 border-2 border-white shadow-lg hover:shadow-xl hover:scale-105 transition-all"
              >
                Ligue Agora
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
